import { hooksApi } from '../index';
import { useMemo } from 'react';

export default function useAPIIdentities() {
  const { data, isLoading, error, invalidate } = hooksApi.useGetV1customerme(
    {
      queries: { recursive: false },
    },
    {
      // Always refetch when the component mounts, even if cached data exists
      refetchOnMount: 'always',
      // Treat data as stale immediately so it's always eligible for refetching
      staleTime: 0,
      // Discard cached data immediately when all subscribers unmount, so re-mounting
      // triggers a fresh initial load (isLoading = true) instead of returning stale data.
      // This prevents stale empty identities from causing incorrect redirects to the wizard.
      cacheTime: 0,
    },
  );

  return useMemo(
    () => ({
      identities: data?.customerList || [],
      isLoadingIdentities: isLoading,
      loadIdentitiesError: error,
      mutateIdentities: invalidate,
    }),
    [data, isLoading, error, invalidate],
  );
}
